import { render } from "./SchedaFatturaView.vue?vue&type=template&id=13902086"
import script from "./SchedaFatturaView.vue?vue&type=script&lang=js"
export * from "./SchedaFatturaView.vue?vue&type=script&lang=js"

import "./SchedaFatturaView.vue?vue&type=style&index=0&id=13902086&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__